import { noop } from '@mindtickle/utils';
import { Link } from 'react-router-dom';

import { AdvanceLinkProps } from '../../type';

const InternalLink = ({ url, children, className, onClick = noop }: AdvanceLinkProps) => (
  <Link to={url} className={className} onClick={onClick}>
    {children}
  </Link>
);

export default InternalLink;
